<template>
  <div class="card">
    <div class="card-header">
      <h5 :class="location.errorAddress ? 'text-danger' : ''">{{ location.storeName }} <span v-if="location.errorAddress" class="text-danger"><font-awesome-icon icon="exclamation-triangle" size="1x" /></span></h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="saveLocation()">

        <div class="form-group col-md-12 mb-3">
          <translate>Address</translate>
          <div v-show="!location._edit || location._edit !== true">
            <span v-if="location.address">{{location.address}}</span>
            <strong v-else v-translate>We were unable to find the address. Please edit it yourself</strong>
            <b-button v-show="location.externalId === 'origin'"  size="sm" variant="link" @click="cleanEdits(); locationEdit = null; location._edit = true" style="padding: .2rem .25rem">
              <font-awesome-icon icon="edit" size="1x" />
            </b-button>
          </div>
        </div>

        <div v-show="location._edit">
          <address-autocomplete @selected="checkLocationPlace($event, location)" static-items :minCharacter="4" class="d-inline-block" style="width:300px" />
          <b-button size="sm" variant="success" @click="saveStreetFields" :disabled="!locationEdit" v-translate>
            Save
          </b-button>
          <b-button size="sm" variant="danger" @click="location._edit = false; locationEdit = null" v-translate>
            Cancel
          </b-button>
        </div>

        <div class="form-group col-md-12 mb-3">
          <b-form-checkbox :value="location.storePickup">
            <translate>Store pickup</translate>
          </b-form-checkbox>
        </div>

        <div class="form-group col-md-12">
          <b-button type="submit" variant="primary" v-translate>Save</b-button>
        </div>
      </form>
    </div>
    <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header @hide="$refs.pickPlaceMap.pickPlace(0, 0)">
      <place-picker ref="pickPlaceMap" @cancel="closeModalPickPlace" @placePicked="setLocationPicked" centerMap fit-always :zoom="17" />
    </b-modal>
  </div>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import PlacePicker from '@/components/PlacePicker'
import { mapGetters } from 'vuex'

export default {
  components: {
    AddressAutocomplete,
    PlacePicker
  },
  mixins: [AddressMixins],
  props: {
    location: {
      type: Object,
      default: () => {}
    },
    application: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hasDescription: this.$route.params.slug === 'shopify-v2',
      locationEdit: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  beforeMount() {
  },
  methods: {
    selectedLocation(item, location) {
      this.locationEdit = location
      this.locationEdit.place_id = item.place_id
    },

    async saveLocation() {
      const path = this.$appConfig.integrations.ecommerce.baseUrl + 'shopify/update-store-pickup?appId=' + this.application.id
      const headers = {
        'x-api-key': this.$appConfig.integrations.ecommerce.header,
        'Authorization': this.application.key
      }

      const body = {
        externalId: this.location.externalId,
        storePickup: this.location.storePickup,
        address: this.location.address,
        storeName: this.location.storeName,
        platformId: this.$appConfig.integrations['shopify-v2'].platformId
      }
      if (this.location.lat) {
        body.lat = Number(this.location.lat)
        body.lng = Number(this.location.lng)
      }

      await this.$http.put(path, body, { headers })
      this.locationEdit = null
      this.$emit('success-updating', true)
    },
    async saveStreetFields() {
      console.log(this.locationEdit)
      this.location = {
        ...this.location,
        lat: this.locationEdit.lat,
        lng: this.locationEdit.lng,
        address: this.locationEdit.formatted_address,
        moovaPlaceId: this.locationEdit.place_id
      }
      await this.saveLocation()
    },
    cleanEdits() {
      this.locationEdit = null
      this.location._edit = false
    },
    async checkLocationPlace(place, location) {
      this.locationEdit = location
      await this.checkPlace(place)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.locationEdit = this.theCheckedAddress
          this.theCheckedAddress = {}
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = {
              lat: this.theCheckedAddress.lat,
              lng: this.theCheckedAddress.lng
            }
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
    },
    setLocationPicked(place) {
      this.locationEdit.place_id = place.id
      this.$refs.modalPickPlace.hide()
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    }
  }
}
</script>
